import React from 'react';
import { Container } from 'reactstrap';
import { bemnames as bn } from 'utils';

const bem = bn.bemNames.create('content');

const Content = ({ tag: Tag, className, ...restProps }) => {
  const classes = bem.b(className);

  return <Tag className={classes} {...restProps} />;
};

Content.defaultProps = {
  tag: Container,
};

export default Content;
